import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { GenSingleImagePreviewData } from '../../../../../../../models/google-template/preview-interfaces/gen-single-image-preview-data.interface';
import { DisplayBrowserChromeComponent } from '../../../preview-common/display/display-browser-chrome/display-browser-chrome.component';
import { MobileFrameComponent } from '../../../preview-common/mobile-frame/mobile-frame.component';

@Component({
    selector: 'app-gen-display-ad-mobile-13',
    imports: [CommonModule, MobileFrameComponent, DisplayBrowserChromeComponent],
    templateUrl: './display-ad-mobile-13.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: [
        '../../../preview-common/display/display-mobile-styles.scss',
        './display-ad-mobile-13.component.scss',
    ]
})
export class DisplayAdMobile13PreviewComponent {
  @Input() data!: GenSingleImagePreviewData;

  /**
   * Row counts for the grey article text the ad is embedded in — the mock shows
   * a paragraph above the ad and a longer run below it that clips at the frame
   * edge. Only the counts matter, so the arrays are empty on purpose.
   */
  readonly topBars = Array.from({ length: 8 });
  readonly bottomBars = Array.from({ length: 14 });
}
